import { Component, Inject, TemplateRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import {
  MatTableDataSource,
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow,
} from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import { ServiceResult } from 'src/app/model/common.model';
import { PopupSettings } from 'src/app/model/popup.model';
import { CommonService } from '../../services/common.service';
import { TranslatorPipe } from '../../pipes/translator.pipe';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { CanvasJSAngularChartsModule } from '@canvasjs/angular-charts';
import { NgIf, NgFor, NgTemplateOutlet } from '@angular/common';
import { labels } from 'src/app/constants/labels.constants';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    CanvasJSAngularChartsModule,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MatTable,
    NgFor,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatIcon,
    ReactiveFormsModule,
    NgTemplateOutlet,
    TranslatorPipe,
  ],
})
export class PopupComponent {
  chartOptions: any;
  analysisResultOption: any;
  customer_notif_title: any;
  customer_notif_content: any;
  description: any;
  customer_notif_link: any;
  chartAnalysis: any;
  isJSONobj = false;
  response_customer_notif: any = false;
  spectrogram: any;
  component = '';
  displayedColumns: string[] = ['seq_no', 'org_repa_name', 'repa_dat', 'con_date'];
  dataSource = new MatTableDataSource<ServiceResult>();
  title = '';
  message!: TemplateRef<any>;
  innerMsg: string | TemplateRef<Element> | undefined = '';
  popupSettings: PopupSettings = <PopupSettings>{};
  privacyNoticeText = '';

  constructor(
    public comSvc: CommonService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<PopupComponent>,
    public sanitizer: DomSanitizer
  ) {
    this.comSvc.reason.reset('');
    this.component = this.data?.['col'];
    if (data) {
      if (data['col'] == 'customer_notification') {
        this.customer_notif_title = data['data']['title'];
        this.customer_notif_content = data['data']['content'];
        this.customer_notif_link = data['data']['video'];
      } else if (data['col'] == 'ai' || data['col'] == 'analysis_result') {
        if (typeof data['data'] == 'object') {
          this.isJSONobj = true;
          this.chartAnalysis = this.data['data'];
          const chartObj: any = [];
          const chartTitle = data['col'] == 'ai' ? 'AI Analysis' : 'Signal Analysis Result';
          this.data['data'].forEach((prob: any) => {
            const temp: any = new Object();
            temp['name'] = prob['label'];
            temp['y'] = +(Number(prob['value']) * 100).toFixed(3);
            chartObj.push(temp);
          });
          this.chartOptions = {
            animationEnabled: true,
            theme: 'dark2',
            exportEnabled: false,
            title: {
              text: chartTitle,
            },

            subtitles: [
              {
                text: 'Probability (%)',
              },
            ],
            data: [
              {
                type: 'pie', //change type to column, line, area, doughnut, etc
                indexLabel: '{name}: {y}%',
                dataPoints: chartObj,
              },
            ],
          };
        } else {
          this.isJSONobj = false;
          this.chartAnalysis = this.data['data'];
        }
      } else if (data['col'] == 'spectrogram') {
        this.spectrogram = this.data['data'];
      } else if (data['col'] == 'show_description') {
        this.description = this.data['data'];
      } else if (data['col'] == 'service_result') {
        this.dataSource = this.data['data'];
      } else if (data['col'] == 'showPrivacyNotice') {
        this.privacyNoticeText = labels['privacyNotice'][this.comSvc.lang].split('\n');
      }
    }
  }
  disableConfirm() {
    if (this.comSvc.reason.value.trim() != '' && this.comSvc.userRole.value != this.data?.cur_role) {
      return false;
    }
    return true;
  }
}
